<template>
    <AllCompaniesFilters
        v-model="filters"
        :has-active-filters="hasActiveFilters"
        :company-type="companyType"
        @submit="applyFilters"
        @reset="resetFilters"
    />
    <v-data-table-server
        :headers="headers"
        :items="items"
        :items-per-page-options="[10, 15, 50, 100]"
        :loading="isLoading"
        :options="options"
        :items-length="companiesCount"
        class="elevation-1 table-server"
        data-cy="clients-table"
        disable-sort
        density="compact"
        color="primary"
        @update:options="onUpdateTableOptions"
    >
        <template v-slot:item.name="{item}">
            <span
                class="text-subtitle-2 text-primary text-decoration-underline cursor-pointer"
                @click="goToCompanyClientProfile(item.id)"
            >
                {{ item.name }}
            </span>
        </template>
        <template v-slot:item.type="{item}">
            {{ item.type ? $t(`companyTypes.${item.type}`) : '' }}
        </template>
        <template v-slot:item.emails="{item}">
            {{ item.emails?.length ? item.emails.join('\n') : '' }}
        </template>
        <template v-slot:item.active="{item}">
            {{ item.active ? $t('active') : $t('inactive') }}
        </template>
    </v-data-table-server>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import __CompaniesTable, {CompaniesTable as _CompaniesTable} from '@/components/account/CompaniesTable.vue'
    import {clean, clone} from '~/utils/helpers'
    import AllCompaniesFilters from '~/components/account/companies/AllCompaniesFilters.vue'

    @Component({
        components: {AllCompaniesFilters},
        mixins: [__CompaniesTable],
    })
    export class AllCompaniesTable extends _CompaniesTable {
        async loadCompanies(): Promise<void> {
            const {itemsPerPage, page} = this.options
            const filters = clone(this.filters)
            clean(filters)
            if (filters.type) Object.assign(filters, {type: filters.type})

            await runtimeStore.loadCompanies({
                ...filters,
                rangeType: 'REGISTRATION',
                shortResponse: true,
                limit: itemsPerPage,
                offset: itemsPerPage * (page - 1),
            })
        }

        async mounted(): Promise<void> {
            this.resetFilters()
        }

        get headers() {
            let headers = [
                {title: this.$t('company_name'), value: 'name'},
                {title: this.$t('company_alias'), value: 'alias'},
                {title: this.$t('company_code'), value: 'code'},
                {title: this.$t('company_type'), value: 'type'},
                {title: this.$t('country'), value: 'country'},
                {title: this.$t('city'), value: 'city'},
                {title: this.$t('phone'), value: 'phone', minWidth: '160px'},
                {title: this.$t('registration'), value: 'registrationDate', minWidth: '100px'},
                {title: this.$t('email'), value: 'emails'},
                {title: this.$t('status'), value: 'active', minWidth: '140px'},
            ]

            return headers
        }
    }

    export default AllCompaniesTable
</script>
